module.exports = ".market-tooltip-block {\n  display: inline-block;\n  padding: 2px 4px 4px 5px; }\n\n.market-tooltip-text {\n  margin: 5px 0 0 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/market/components/map/market-tooltip.component.scss
// module id = ./src/app/features/market/components/map/market-tooltip.component.scss
// module chunks = main